export enum RouteEnum {
  Login = '/login',
  Verification = '/verification',
  Partners = '/instructor/partners',
  AuditQueue = '/queue',
  NeedsReview = '/review',
  IncompleteAudits = '/incomplete',
  Courses = '/instructor/partners/:partner/courses/*',
  Exams = '/instructor/partners/:partner/courses/:course/exams/*',
  ExamSessions = '/instructor/partners/:partner/courses/:course/exam/:exam',
  ExamAudit = '/instructor/audit/:session',
  EnhancedAudit = '/audit/:audit',
  Review = '/review/audit/:session/:audit',
  TargetReport = '/target-report/:session',
}
